import React from 'react';
import PropTypes from 'prop-types';
import { ClockIcon } from '../../../model/icons';
import BetAccordion from './BetAccordion';
import BetRow from './BetRow';
import { formatDt, betsLabel, sortScores } from './betUtils';

// Карточка спортивного события (.bt-ev): команды, коэффициенты, точный счёт, ставки.
export default function SportEventCard({ event, bets, colorOf, finished, onEdit, onFinish, onDelete }) {
    const { team1, team2, startTime, result, winTeamId, oddsTeam1, oddsDraw, oddsTeam2, specificResultOdds } = event;
    const win1 = finished && winTeamId === team1.teamId;
    const win2 = finished && winTeamId === team2.teamId;
    const winX = finished && !winTeamId;
    const scores = specificResultOdds ? sortScores(specificResultOdds) : [];

    return (
        <div className={`bt-ev${finished ? ' done' : ''}`}>
            <div className="eh">
                <div className="etitle">
                    <span className={`tt${win1 ? ' win' : ''}`}>
                        <span className="bdot" style={{ background: colorOf(team1.teamId) }} />{team1.name}
                    </span>
                    {finished ? <span className="scr">{result}</span> : <span className="vs">vs</span>}
                    <span className={`tt${win2 ? ' win' : ''}`}>
                        <span className="bdot" style={{ background: colorOf(team2.teamId) }} />{team2.name}
                    </span>
                </div>
                <span className={`bt-badge ${finished ? 'done' : 'active'}`}>{finished ? 'Завершено' : 'Активно'}</span>
            </div>

            <div className="edt"><span className="ci"><ClockIcon /></span>{formatDt(startTime)}</div>

            <div className="bt-odds">
                <div className={`bt-odd${win1 ? ' win' : ''}`}><div className="ok">П1</div><div className="ov">{Number(oddsTeam1 || 0).toFixed(2)}</div></div>
                <div className={`bt-odd${winX ? ' win' : ''}`}><div className="ok">X</div><div className="ov">{Number(oddsDraw || 0).toFixed(2)}</div></div>
                <div className={`bt-odd${win2 ? ' win' : ''}`}><div className="ok">П2</div><div className="ov">{Number(oddsTeam2 || 0).toFixed(2)}</div></div>
            </div>

            {scores.length > 0 && (
                <BetAccordion label={`Точный счёт (${scores.length} вариантов)`}>
                    <div className="bt-scores">
                        {scores.map(([score, odd]) => (
                            <div key={score} className={`bt-score${finished && score === result ? ' win' : ''}`}>
                                <div className="s">{score}</div>
                                <div className="k">{Number(odd).toFixed(2)}</div>
                            </div>
                        ))}
                    </div>
                </BetAccordion>
            )}

            {bets.length > 0 && (
                <BetAccordion label={betsLabel(bets, finished)}>
                    <div className="bt-bets">
                        {bets.map(bet => <BetRow key={bet.id} bet={bet} finished={finished} />)}
                    </div>
                </BetAccordion>
            )}

            {!finished && (
                <div className="bt-foot">
                    <button type="button" className="btn btn-danger" onClick={onDelete}>Удалить</button>
                    <button type="button" className="btn btn-ghost" onClick={onEdit}>Изменить</button>
                    <button type="button" className="btn btn-primary" onClick={onFinish}>Завершить</button>
                </div>
            )}
        </div>
    );
}

SportEventCard.propTypes = {
    event: PropTypes.object.isRequired,
    bets: PropTypes.array,
    colorOf: PropTypes.func.isRequired,
    finished: PropTypes.bool,
    onEdit: PropTypes.func,
    onFinish: PropTypes.func,
    onDelete: PropTypes.func
};

SportEventCard.defaultProps = { bets: [], finished: false, onEdit: undefined, onFinish: undefined, onDelete: undefined };
